import axios from 'axios';
import { API_URL, WHITELABEL_ID } from '../constants';

const api = axios.create({
  baseURL: `${API_URL}/api/wl/${WHITELABEL_ID}`,
  // Let's leave it commented because file uploading doesn't work with application/json
  // headers: {
  //     "Content-Type": "application/json",
  // },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.log(error);
    if (error.response) {
      console.error('Response error:', error.response);
      if (error.response.status === 401) {
        console.log('Unauthorized, logging out...');
        localStorage.removeItem('authToken');
        window.location.href = '/';
      }
    } else if (error.request) {
      console.error('Request error:', error.request);
    } else {
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default api;
